import { IsNotEmpty } from "class-validator";

export default class DeleteShopReq {
  @IsNotEmpty({
    message: "",
  })
  readonly shopId: number;

  constructor(arg: any) {
    arg = arg || {};
    this.shopId = arg.shopId;
  }
}
